const priceFormatter = new Intl.NumberFormat('hu-HU');

export const PRICE_BY_AGREEMENT = 'Egyeztetés alapján';

/**
 * A supply's price as the guest reads it. A supply without a price (SUPPLY.price is NULL, which
 * the API leaves out of the JSON altogether) has no fixed price: it is agreed on with the tenant,
 * so it reads „Egyeztetés alapján” rather than „0 Ft”.
 */
export const formatPrice = (price) => (
  price === null || price === undefined
    ? PRICE_BY_AGREEMENT
    : `${priceFormatter.format(price)} Ft`
);
